import './keyword-input.scss';

import KeywordInput from './KeywordInput';

export default KeywordInput;
